export default __webpack_public_path__ + "static/media/status-released-icon.fd59f61e.svg";